import React from 'react';
import { colors } from "../../maps/colors";
import UploadProfileImage from "./UploadProfileImage";
import IconButton from "@mui/material/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import Icn from "../Icn";
import Tx from "../Tx";
import styled from "styled-components";

const WrapperStyled = styled.div`
  text-align: center;
  margin-bottom: 10px;
  
  &.disabled{
    pointer-events: none;
    cursor: none;
  }
`;

const UploadProfileImageStyled = styled.div`
  position: relative;
  display: inline-block;
  width: 160px;
  height: 160px;
  border: 1px solid ${colors.GRAY3};
`;

const DeleteImageIconWrapperStyled = styled.div`
  position: absolute;
  right: -40px;
  top: 0;
`;

const UploadProfileImageBox = ({ image, onImageSelect, removeImageHandle, disableCrop, disabled }) => {
    return (
        <WrapperStyled className={disabled ? 'disabled' : ""}>
            <UploadProfileImageStyled>
                <UploadProfileImage
                    onImageSelect={onImageSelect}
                    disableCrop={disableCrop}
                />
                {image && (
                    <>
                        <img src={image}
                            alt="shopper image"
                            style={{ maxWidth: 160, maxHeight: 160, padding: 10 }} />
                        <DeleteImageIconWrapperStyled>
                            <IconButton aria-label="delete" size="small" onClick={removeImageHandle}>
                                <DeleteIcon fontSize="inherit" />
                            </IconButton>
                        </DeleteImageIconWrapperStyled>
                    </>
                )}
                {!image && (
                    <>
                        <Icn style={{
                            position: 'absolute',
                            top: 10,
                            left: 10,
                            color: colors.GRAY3
                        }}>addAPhotoIcon</Icn>
                        <Tx style={{
                            position: 'absolute',
                            top: 60,
                            width: 160,
                            left: 0,
                            fontSize: 11
                        }}>shopper.addShopper.addImage</Tx>
                    </>
                )}
            </UploadProfileImageStyled>
        </WrapperStyled>
    );
};

export default UploadProfileImageBox;